module.exports = __webpack_public_path__ + "img/google-play-login.602ab375.png";